import { __rest } from "tslib";
import React, { useMemo } from 'react';
import { object, string } from 'prop-types';
import BaseFormField from './BaseFormField';
import PasswordInput from './PasswordInput';
export default function PasswordField(props) {
    const { placeholder, autoComplete, buttonLabelShow, buttonLabelHide, inputProps } = props, otherProps = __rest(props, ["placeholder", "autoComplete", "buttonLabelShow", "buttonLabelHide", "inputProps"]);
    const inputPropsToUse = useMemo(() => (Object.assign({ placeholder,
        autoComplete,
        buttonLabelShow,
        buttonLabelHide }, inputProps)), [placeholder, autoComplete, buttonLabelShow, buttonLabelHide, inputProps]);
    // We don't expect this prop but other fields have it so we just warn the devs
    //eslint-disable-next-line react/prop-types
    if (props.isSensitive) {
        console.warn('The isSensitive prop is being ignored as the Password field is a sensitive field by default');
    }
    return React.createElement(BaseFormField, Object.assign({}, otherProps, { component: PasswordInput, inputProps: inputPropsToUse }));
}
PasswordField.propTypes = {
    /** Input placeholder shown when the field is empty */
    placeholder: string,
    /** Controls autocomplete behaviour (see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) */
    autoComplete: string,
    /** Extra props to be passed directly to the PasswordInput */
    inputProps: object,
    /** Label applied to the "Show" button */
    buttonLabelShow: string,
    /** Label applied to the "Hide" button */
    buttonLabelHide: string,
    label: string,
    name: string,
};
//# sourceMappingURL=PasswordField.js.map